import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import cacheKeys from '@/data/api/cacheKeys';
import { setAddressAsFavorite } from '@/data/api/request/buyersRequests';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useSetFavoriteAddress() {
  const queryClient = useQueryClient();
  const { showSnackSuccess, showSnackError } = useSnackbarContext();

  const mutation = useMutation({
    mutationFn: async (args: { buyerId: string; addressId: string }) => {
      await setAddressAsFavorite({
        buyerId: args.buyerId,
        addressId: args.addressId,
      });
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.buyer.addresses, variables.buyerId],
      });
      showSnackSuccess('Dirección marcada como favorita');
    },
    onError: () => showSnackError('Error al marcar la dirección como favorita'),
  });

  return mutation;
}
